export const GET_USER_DETAIL = 'GET_USER_DETAIL';
